/**
 * Identifiant unique de cet onglet, envoyé à l'API pour qu'elle ne nous renvoie pas
 * en temps réel l'écho de nos propres modifications.
 */
export const clientId: string = crypto.randomUUID();
